<template>
    <div class="sensor-readings" v-if="shown.length">
        <div class="sensor-reading" v-for="one in shown" :key="one.label">
            <div class="sensor-reading-label">{{ $t(one.label) }}</div>
            <div class="sensor-reading-value">{{ one.text }}</div>
        </div>
    </div>
</template>

<script>
/**
 * What a sensor is reading, each number under the word for what it is.
 *
 * The dashboard used to show bare figures - 83% next to 0.5 m/s - which left
 * you to work out which was which. The same list is drawn in the app, so a
 * reading is named the same way on both.
 *
 * module_values stores everything as text and the keys differ between devices,
 * so each reading names the keys it may arrive under.
 */

const READINGS = [
    {
        label: 'TEMPERATURE', keys: ['Temperature', 'temperature'], unit: '℃', digits: 1,
    },
    {
        label: 'NSP_HUMIDITY', keys: ['Humidity', 'humidity'], unit: '%', digits: 1,
    },
    {
        label: 'NSP_CO2', keys: ['CarbonDioxide'], unit: ' ppm', digits: 0,
    },
    {
        label: 'NSP_DEW_POINT', keys: ['DewPoint', 'dew_point'], unit: '℃', digits: 1,
    },
    {
        label: 'NSP_PRESSURE', keys: ['pressure'], unit: ' hPa', digits: 0,
    },
    {
        label: 'NSP_WIND', keys: ['wind_speed'], unit: ' m/s', digits: 1,
    },
    {
        label: 'NSP_GUST', keys: ['gust_speed'], unit: ' m/s', digits: 1,
    },
    {
        label: 'NSP_UV', keys: ['uv'], unit: '', digits: 1,
    },
    {
        label: 'NSP_LIGHT', keys: ['illuminance'], unit: ' lx', digits: 0,
    },
    {
        label: 'NSP_RAIN_TOTAL', keys: ['precipitation'], unit: ' mm', digits: 1,
    },
];

export default
{
    name: 'SensorReadings',
    props:
    {
        module:
        {
            type: Object,
            required: true,
        },
    },
    computed:
    {
        shown()
        {
            const me = this;
            const values = me.module.values || {};
            const out = [];

            for (const one of READINGS)
            {
                // a reading of 0 is a reading, so this cannot lean on truthiness
                let found = null;

                for (const key of one.keys)
                {
                    const parsed = parseFloat(values[key]);

                    if (!Number.isNaN(parsed))
                    {
                        found = parsed;
                        break;
                    }
                }

                if (found !== null)
                {
                    out.push({ label: one.label, text: found.toFixed(one.digits) + one.unit });
                }
            }

            return out;
        },
    },
};
</script>
